import React, { ElementType } from 'react'
import { TypographyProps, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { TOptions } from 'i18next'

type Props = {
  translationKey: string
  translationDefaultValue?: string
  options?: TOptions
  ns?: string[]
  component?: ElementType
  children?: string
  suffix?: string
  html?: boolean
  href?: string
} & TypographyProps

export const LocalizedTypography = (props: Props) => {
  const {
    translationKey,
    ns,
    translationDefaultValue: defaultValue,
    options,
    suffix,
    children,
    ...typographyProps
  } = props

  const { t } = useTranslation(
    ...[
      translationKey.indexOf(':') > 0 ? translationKey.split(':')[0] : [],
      ...(ns ?? []),
    ]
  )

  typographyProps.variant = typographyProps.variant || 'inherit'

  if (props.html) {
    return (
      <Typography
        component={props.component || 'span'}
        dangerouslySetInnerHTML={{
          __html: t(translationKey, options).toString(),
        }}
        {...typographyProps}
      />
    )
  } else {
    return (
      <Typography component={props.component || 'span'} {...typographyProps}>
        {`${t(translationKey, options ?? children ?? defaultValue)}${
          suffix ?? ''
        }`}
      </Typography>
    )
  }
}
